module.exports = __webpack_public_path__ + "static/media/autodesk_atlas_t_header.73550354.png";